// Date/time formatting and description helpers for calendar events. Kept free of
// React and Markdown deps so they're easy to unit-test and reuse.

const MONTHS = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];

// Compact date badge + human time for an event's start (in the viewer's locale).
export function eventWhen(ev) {
  if (!ev || !ev.start) return { month: '', day: '', time: '' };
  const d = new Date(ev.start);
  if (Number.isNaN(d.getTime())) return { month: '', day: '', time: '' };
  return {
    month: MONTHS[d.getMonth()],
    day: String(d.getDate()),
    time: ev.allDay ? '' : d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' }),
  };
}

// A fuller, human date/time line for the details modal (viewer's locale).
export function fullWhen(ev) {
  if (!ev || !ev.start) return '';
  const d = new Date(ev.start);
  if (Number.isNaN(d.getTime())) return '';
  const date = d.toLocaleDateString([], { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' });
  if (ev.allDay) return `${date} · All day`;
  const opts = { hour: 'numeric', minute: '2-digit' };
  let line = `${date} · ${d.toLocaleTimeString([], opts)}`;
  if (ev.end) {
    const e = new Date(ev.end);
    if (!Number.isNaN(e.getTime())) line += ` – ${e.toLocaleTimeString([], opts)}`;
  }
  return line;
}

// Short plain-text excerpt of a Markdown description for the event card. Strips
// the common Markdown syntax to readable text and truncates on a word boundary
// so cards stay uniform; the full Markdown is rendered in the details modal.
export function plainPreview(md, maxLen = 150) {
  if (!md) return '';
  const text = String(md)
    .replace(/!\[[^\]]*\]\([^)]*\)/g, '') // images -> nothing
    .replace(/\[([^\]]*)\]\([^)]*\)/g, '$1') // links -> their text
    .replace(/`([^`]*)`/g, '$1') // inline code -> contents
    .replace(/^\s{0,3}(#{1,6}\s|>\s?|[-*+]\s|\d+\.\s)/gm, '') // headings/quotes/list markers
    .replace(/[*_~]+/g, '') // emphasis markers
    .replace(/\s+/g, ' ')
    .trim();
  if (text.length <= maxLen) return text;
  const cut = text.slice(0, maxLen);
  const sp = cut.lastIndexOf(' ');
  return `${(sp > 80 ? cut.slice(0, sp) : cut).trim()}…`;
}
